type Props = {
    cssStyles?: string
}

export function Dot({ cssStyles = 'text-red-500' }: Props) {
    return <span className={cssStyles}>•</span>
}